import { FC } from 'react';

import { SelectionBadgeContainer } from './styles';
import { Typography } from '../Typograph';

interface ISelectionBadgeProps {
  selected: boolean;
  title: string;
  onSelect: () => void;
  variant?: 'default' | 'subcategory';
}
export const SelectionBadge: FC<ISelectionBadgeProps> = ({
  selected,
  title,
  onSelect,
  variant = 'default',
}) => {
  return (
    <SelectionBadgeContainer
      onClick={onSelect}
      aria-pressed={selected}
      $selected={selected}
      $variant={variant}
    >
      <Typography.Label
        size="x-small"
        color={
          selected
            ? 'neutral1000'
            : variant === 'subcategory'
            ? 'primary'
            : 'neutral200'
        }
      >
        {title}
      </Typography.Label>
    </SelectionBadgeContainer>
  );
};
